"use strict";

import $ from "jquery";
/**
 * Works with 'menu' children as menu items, and takes 'items' children as corresponding slides
 * @return {[undefined]}       [nothing returned]
 */

export default function menu(options) {
    /* accordion data-parameters
     * @param  {[number]} speed    [speed in ms]
     * @param  {[string]} object    [selector of toggled element]
     * @param  {[animation]} object    [toggling animation]
     */

    const $menu = $(options.selector);
    const activeMenuClass = options.menuItemClass + "--active";
    const activeItemClass = options.itemsItemClass + "--active";
    const toggle = options.toggle;

    // instance for each matching selector item
    $menu.each(function (menuIndex, instance) {
        const $instance = $(instance);
        const itemsSelector = $instance.data("menuItems");
        const $items = $(itemsSelector).find("." + options.itemsItemClass);
        const $menuItems = $instance.find("." + options.menuItemClass);

        $menuItems.each(function (index, el) {
            const $menuItem = $(el);

            $menuItem.click(function (e) {
                e.preventDefault();
                let shouldBecomeActive = true;

                if (toggle && $menuItem.hasClass(activeMenuClass)) {
                    shouldBecomeActive = false;
                }

                $menuItems.removeClass(activeMenuClass);
                $items.removeClass(activeItemClass);

                if (shouldBecomeActive) {
                    $items.eq(index).addClass(activeItemClass);
                    $menuItem.addClass(activeMenuClass);
                }

                if (options.callback) {
                    options.callback(e);
                }
            });
        });
    });
}
